// Registry for the auth-token refresh handler request() calls to recover a 401.
// Registered only for a v2 (OIDC) session; brand-agnostic so requestUtils stays
// decoupled from the OIDC layer.
export type AuthTokenRefreshHandler = (options?: { force?: boolean }) => Promise<string | undefined>

let handler: AuthTokenRefreshHandler | undefined

export function registerAuthTokenRefreshHandler(next: AuthTokenRefreshHandler): void {
  handler = next
}

export function unregisterAuthTokenRefreshHandler(current: AuthTokenRefreshHandler): void {
  if (handler === current) {
    handler = undefined
  }
}

export function getAuthTokenRefreshHandler(): AuthTokenRefreshHandler | undefined {
  return handler
}
